import React from "react";
import PropTypes from "prop-types";
import BoldTypography from "components/BoldTypography";
import contractorNameBuilder from "libs/contractorNameBuilder";
import Typography from "components/Typography";

function CorrespondenceEmailList(
    {
        wrapper,
        className
    }) {

    return <div className={className}>
        <BoldTypography>{contractorNameBuilder(wrapper.recipient)}</BoldTypography>
        <ul>
            {wrapper.emails.map((x, i) => <li key={i}><Typography>{`${i+1}. ${x}`}</Typography></li>)}
        </ul>
    </div>;

}

CorrespondenceEmailList.propTypes = {
    wrapper: PropTypes.shape({
        recipient: PropTypes.object.isRequired,
        emails: PropTypes.arrayOf(PropTypes.string).isRequired
    }).isRequired
}
export default CorrespondenceEmailList;

